<template>
   <el-container class="content" style="display: block;">

     <div >
       <img @click="goHome()"  :src="require('@/assets/image/goback.png')" style="position: absolute;left: 0;top: 0;z-index: 1008;opacity: 0.8;" :style="{'height':screenHeight*0.03+'px'}" >
     </div>
    <div :style="{'width':otherWidth+'px','height':leftheight+'px'}" style="display: flex;flex-wrap: wrap;background-color: #000;overflow-y: scroll;">

      <div class="shop2_search" :style="{'width':otherWidth*0.5+'px','left':otherWidth*0.25+'px'}" >
      	<input class="shop2_searchi" v-model="search" @keydown.enter="loadListV()" style="width: 100%;height: 99%;" />

      	<button class="shop2_searcht"  @click="loadListV()"  >搜索</button>

      </div>
      <div v-for="(video, index) in list" :key="index" style="overflow: hidden;">


        <div class="donghuap" :style="{'width':vwidth+'px','height':vwidth+'px'}" style="overflow: hidden;">
          <!-- <div @click="open(video['url'])"  class="donghuai" :class="{ddonghua:(video['typed'] == 0),edonghua:(video['typec'] == 1),adonghua:(video['typea'] == 1)}" :style="{'background-image':`url(${video['bkg']})`}">

            <img :src="video['img']"  :width="vwidth" :height="vwidth" style="object-fit: contain;">
          </div> -->
          <div @click="open(video['url'])"  :style="{'background-image':`url(${video['bkg']})`}">
            <video v-if="video['v_url'] != '无'" autoplay loop muted playsinline style="object-fit: contain;" :style="{'width': vwidth+'px','height': vwidth+'px'}">
              <source :src="video['v_url']" type="video/mp4" />
            </video>
            <img v-else :src="video['img']"  :width="vwidth" :height="vwidth" style="object-fit: contain;">
            
          </div>
          <div :class="{ddonghua:(video['typed'] == 1),edonghua:(video['typeb'] == 1),adonghua:(video['typea'] == 2)}" class="donghuai" @click="open(video['url'])"  :style="{'width':vwidth+'px','height':vwidth+'px','margin-left':'-'+vwidth+'px'}" style="color: #ffffff;text-align: center;" >
            <div class="shop2_wenzi" :style="{'margin-top':vwidth*0.75+'px','width':vwidth+'px','height':vwidth*0.25+'px','line-height':vwidth*0.25+'px'}" style="white-space: nowrap;overflow: hidden;">{{video['ci']}}</div>
          </div>
        </div>

      </div>
    </div>
    <div style="position: absolute;top: 0;z-index: 1005;background-color: #000;z-index: 1005;"  :style="{'width':screenHeight+'px','height':screenHeight+'px','left':otherWidth+'px'}">
      <video width="100%" height="100%" ref="videoPlayer" @ended="restartVideo" controls controlslist="nodownload noplaybackrate" disablePictureInPicture="true" id="myVideo" v-if="ishow" >
        <source :src="video_url" type="video/mp4">

      </video>
      <div class="float-animation" style="z-index: 1006;color: #ffffff;position: absolute;top: 10%;border: 1px solid #fff;" v-if="dinggou2 == 2" @click="dg(1)">
        <img :src="dinggou"  :width="120" :height="100" style="object-fit: contain;">
        <div style="text-align: center;">全球订购</div>

      </div>
      <div class="float-animation1" style="z-index: 1006;color: #ffffff;position: absolute;top: 10%;border: 1px solid #fff;" v-if="daili2 == 2" @click="dl(1)">
        <img :src="daili"  :width="120" :height="100" style="object-fit: contain;">
        <div style="text-align: center;">全球代理</div>

      </div>
      <div  style="z-index: 1006;color: #ffffff;position: absolute;bottom: 0;right:0%;border: 1px solid #fff;width: 40%;height: 40%;background-color: #000;" v-if="daili2 == 1" >
        <div style="color: #fff;text-align: center;margin-top: 2%;">全球代理</div>
        <el-row :span="2" style="margin-top: 10%;margin-left: 5%;">
            <el-col :span="4" style="margin-top: 7px;">
              称呼:
            </el-col>
            <el-col :span="16">
              <el-input v-model="qiye" style="width: 200px;" placeholder="请输入您的姓名/公司名"></el-input>
            </el-col>
        </el-row>
        <el-row :span="2" style="margin-top: 10px;margin-left: 5%;">
            <el-col :span="4" style="margin-top: 7px;">
              电话:
            </el-col>
            <el-col :span="16">
              <el-input v-model="email" style="width: 200px;" placeholder="请输入您的手机号"></el-input>
            </el-col>
        </el-row>
        <el-row :span="2" style="margin-top: 10px;margin-left: 5%;">
            <el-col :span="4" style="margin-top: 7px;">
              其他:
            </el-col>
            <el-col :span="16">
              <el-input v-model="other" style="width: 200px;" placeholder="请输入您的其他联系方式"></el-input>
            </el-col>
        </el-row>
        <el-row :span="2" style="margin-top: 20px;margin-left: 30%;">
            <el-button type="primary" style="background-color: #409eff;" @click="commitdl()" round>提交</el-button>
        </el-row>
        <div  style="z-index: 1006;color: #ffffff;" v-if="daili" @click="dg()">
          <img :src="daili"  width="80%" height="80%" style="object-fit: contain;position: absolute;bottom: 0;right: -20%;">


        </div>
        <div style="position: absolute;right:2px;top:2px;" @click="dl(2)"><i class="el-icon-circle-close" style="font-size: 25px;color: #ffffff;"></i></div>
      </div>
      <div  style="z-index: 1006;color: #ffffff;position: absolute;bottom: 0;border: 1px solid #fff;width: 40%;height: 40%;background-color: #000;" v-if="dinggou2 == 1" >
        <div style="color: #fff;text-align: center;margin-top: 2%;">全球订购</div>
        <el-row :span="2" style="margin-top: 10%;margin-left: 5%;">
            <el-col :span="4" style="margin-top: 7px;">
              称呼:
            </el-col>
            <el-col :span="16">
              <el-input v-model="qiye1" style="width: 200px;" placeholder="请输入您的姓名/公司名"></el-input>
            </el-col>
        </el-row>
        <el-row :span="2" style="margin-top: 10px;margin-left: 5%;">
            <el-col :span="4" style="margin-top: 7px;">
              电话:
            </el-col>
            <el-col :span="16">
              <el-input v-model="email1" style="width: 200px;" placeholder="请输入您的手机号"></el-input>
            </el-col>
        </el-row>
        <el-row :span="2" style="margin-top: 10px;margin-left: 5%;">
            <el-col :span="4" style="margin-top: 7px;">
              其他:
            </el-col>
            <el-col :span="16">
              <el-input v-model="other1" style="width: 200px;" placeholder="请输入您的其他联系方式"></el-input>
            </el-col>
        </el-row>
        <el-row :span="2" style="margin-top: 20px;margin-left: 30%;">
            <el-button type="primary" style="background-color: #409eff;" @click="commitdg()" round>提交</el-button>
        </el-row>
        <div  style="z-index: 1006;color: #ffffff;" v-if="dinggou" @click="dg()">
          <img :src="dinggou"  width="80%" height="80%" style="object-fit: contain;position: absolute;bottom: 0;right: -20%;">


        </div>
        <div style="position: absolute;right:2px;top:2px;" @click="dg(2)"><i class="el-icon-circle-close" style="font-size: 25px;color: #ffffff;"></i></div>
      </div>
    </div>

    <div style="position: absolute;top: 0;z-index: 1005;background-color: #000;z-index: 1005;overflow-y: scroll;"  :style="{'width':otherWidth+'px','height':screenHeight+'px','right':0}">
      <ul style="color: #000000;width: 100%;overflow-y: scroll;display: flex;flex-direction: column;">

        <li v-for="(item, index) in texts" :key="index" @click="open(item['url'])" style="box-shadow: inset 0px 0px 2px rgba(0, 0, 0, 0.5);padding: 1px;" :style="{'background-color':'#'+item['color']}">{{item['name']}}</li>


      </ul>

    </div>
    <div class="beian1">
     <a href="http://beian.miit.gov.cn/state/outPortal/loginPortal.action" rel="noreferrer" target="_blank" style="text-decoration:none;color: #fff;background-color: black;">粤ICP备2024237244号@2024 © 宇宙之幂</a>


    </div>

   </el-container>







</template>


<script>

  export default {
    data() {
      return {
        qiye:'',
        email:'',
        other:'',
        qiye1:'',
        email1:'',
        other1:'',
        dlurl:'',
        dgurl:'',
        cshow:false,
        cshow1:false,
        cshow2:false,
        cshow3:false,
        vshow:false,
        list:[],
        shopkb:[],
        daili2:3,
        dinggou2:3,
        daili:'',
        dinggou:'',
        dailis:[],
        dinggous:[],
        texts:[],
        ishow:true,
        videos:[],
        video_url:'',
        id:this.$route.query.id,
        screenWidth : window.innerWidth,
        screenHeight : window.innerHeight,
        otherWidth:(window.innerWidth-window.innerHeight)/2,
        vwidth:((window.innerWidth-window.innerHeight)/2-12)/6,
        vheight : window.innerHeight/200,
        leftheight:0,
        search:'',
        interval2tu:null,
        interval2:null

      };
    },
    mounted() {


      },
      beforeDestroy() {

      },
    created() {

      this.loadList()
      this.getScreen()



    },

	methods:{
    goHome() {

      this.$router.push('/shop1');
    },
    getScreen() {
      if(navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i )){
        window.location.href='http://m.universe.top/shop2?id='+this.id

      }

    },
    commitdl(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      if(this.qiye == ''){
        this.msg('请填写您的名称','error')
        return false
      }
      if(this.email == ''){
        this.msg('请填写您的手机号','error')
        return false
      }
      axiosInstance({
      	method:'get',
      	params:{
          name:this.qiye,
          email:this.email,
          other:this.other

      	},
      	url:'https://tossp.yoooooo.com/index.php/index/data/videoDl'
      })
      .then(res=>{
        this.qiye = '';
        this.email = '';
        this.other = '';
        this.msg('提交成功','success');
        this.dl(2)
      })
      .catch(err=>{

      });
    },
    commitdg(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      if(this.qiye1 == ''){
        this.msg('请填写您的名称','error')
        return false
      }
      if(this.email1 == ''){
        this.msg('请填写您的手机号','error')
        return false
      }
      axiosInstance({
      	method:'get',
      	params:{
          name:this.qiye1,
          email:this.email1,
          other:this.other1

      	},
      	url:'https://tossp.yoooooo.com/index.php/index/data/videoDg'
      })
      .then(res=>{
        this.qiye1 = '';
        this.email1 = '';
        this.other1 = '';
        this.msg('提交成功','success');
        this.dg(2)
      })
      .catch(err=>{

      });
    },
    dg(t){
      this.dinggou2 = t
      this.open(this.dgurl)
    },
    dl(t){
      this.daili2 = t
      this.open(this.dlurl)
    },
    restartVideo() {
      this.$refs.videoPlayer.currentTime = 0;
      this.$refs.videoPlayer.play();
    },
    open(url){
      if(url == '无'){
        return false
      }
      this.ishow = false
      this.video_url = ""
      setTimeout(() => {
        this.ishow = true
        this.video_url = url

        this.$nextTick(() => {
          if (this.$refs.videoPlayer) {
            this.$refs.videoPlayer.play();
          }
        });
      }, 200);

    },

    startVideo() {
      var that = this
      if (this.interval2) {
        clearInterval(this.interval2);
        this.interval2 = null;
      }
      this.interval2 = setInterval(() => {

        that.list.forEach(function(item, index) {

          if(item['num']<item['nums']){
            item['num'] = item['num']+1;
            that.$set(that.list,index,item);
            // that.$set(that.list, index, {'id':item['id'],'img':item['img'],'name':item['name'],'url':item['url'],'num':item['num']+1,'nums':item['nums'],'typea':item['typea'],'typeb':item['typeb'],'typec':item['typec'],'typed':item['typed']});
          }else{
            if(item['typed'] == 0){
              item['typed'] = 1;
              item['typec'] = 1;

              item['num'] = 0;
              item['nums'] = item['numz'];
              that.$set(that.list,index,item);
              setTimeout(()=>{
                item['typec'] = 2;
                item['typea'] = 1;
                that.$set(that.list,index,item);
              },400);
              setTimeout(()=>{
                item['typea'] = 0;
                that.$set(that.list,index,item);
              },800);
            }else{
              item['typed'] = 0;
              item['typeb'] = 1;

              item['num'] = 0;
              item['nums'] = item['numt'];
              that.$set(that.list,index,item);

              setTimeout(()=>{
                item['typeb'] = 2;
                item['typea'] = 2;
                that.$set(that.list,index,item);
              },400);
              setTimeout(()=>{
                item['typea'] = 0;
                that.$set(that.list,index,item);
              },800);
            }

          }

        })

      }, 1000);

    },
    startTu() {
      var that = this
      var dl = 0;
      var dg = 0;
      if (this.interval2tu) {
        clearInterval(this.interval2tu);
        this.interval2tu = null;
      }
      this.interval2tu = setInterval(() => {
        if(dl == 5){
          dl = 0
          var ks = Math.floor(Math.random() * (that.dailis.length-1));
          that.daili =  that.dailis[ks]['url'];
        }else{
          dl = dl + 1
        }
        if(dg == 7){
          dg = 0
          var ks = Math.floor(Math.random() * (that.dinggous.length-1));
          that.dinggou =  that.dinggous[ks]['url'];
        }else{
          dg = dg + 1
        }


      }, 1000);

    },
    toPage(name){
      this.$router.push('/'+name);
    },
    loadListV(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'get',
      	params:{
          name:this.search,
          id:this.id

      	},
      	url:'https://tossp.yoooooo.com/index.php/index/data/videoListsv'
      })
      .then(res=>{
        this.list = res.data.list;
        this.shopkb = res.data.shopkb;
        var that = this
        this.list.forEach(function(item, index) {
           item['typed'] = 1;
           item['typec'] = 2;
           item['typeb'] = 2;
           item['typea'] = 0;
           var ks = Math.floor(Math.random() * (that.shopkb.length-1));
           item['bkg'] = that.shopkb[ks]['img'];
        })
        this.startVideo()
        // this.startTu()
        this.video_url = this.list[0]['url']

        this.open(this.list[0]['url'])
        var hei = Math.ceil(this.list.length/6)*(this.vwidth+2)

        if(hei > this.screenHeight){
          this.leftheight = this.screenHeight
        }else{
          this.leftheight = Math.ceil(this.list.length/6)*(this.vwidth+2)
        }


      })
      .catch(err=>{

      });
    },
    loadList(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'get',
      	params:{
          name:'宇宙一次幂(深圳)机器人有限公司',
          id:this.id

      	},
      	url:'https://tossp.yoooooo.com/index.php/index/data/videoLists'
      })
      .then(res=>{
        this.list = res.data.list;
        this.texts = res.data.texts;
        this.shopkb = res.data.shopkb;
        this.dailis = res.data.shopdl;
        this.dinggous = res.data.shopdg;
        this.daili =  this.dailis[0]['url'];
        this.dinggou =  this.dinggous[0]['url'];
        this.dlurl = res.data.url['dlurl'];
        this.dgurl = res.data.url['dgurl'];
        var that = this
        this.list.forEach(function(item, index) {
           item['typed'] = 1;
           item['typec'] = 2;
           item['typeb'] = 2;
           item['typea'] = 0;
           var ks = Math.floor(Math.random() * (that.shopkb.length-1));
           item['bkg'] = that.shopkb[ks]['img'];
        })
        this.startVideo()
        this.startTu()
        this.video_url = this.list[0]['url']
        this.daili2 = 2
        this.dinggou2 = 2
        this.open(this.list[0]['url'])
        var hei = Math.ceil(this.list.length/6)*(this.vwidth+2)

        if(hei > this.screenHeight){
          this.leftheight = this.screenHeight
        }else{
          this.leftheight = Math.ceil(this.list.length/6)*(this.vwidth+2)
        }


      })
      .catch(err=>{

      });
    },
		msg(msg,type){
			this.$message({
			  message: msg,
			  type: type
			});
		},



	}


  }
</script>

<style>
.shop2_wenzi{
	background-image: url("../../assets/image/wenzi.png");
	background-repeat: no-repeat;
	background-size:100% 100%;
	color: #0071a1;
	font-weight: 600;
	font-size: 80%;
	font-family:'hanyi75';
	opacity: 0.8;

}
.shop2_searcht{
	position: absolute;
	height: 42px;
	/* line-height: 42px; */
	width: 15%;
	min-width: 80px;
	max-width: 100px;
	font-size: 90%;
	color: #fff;
	z-index: 99999;
	top: 0;
	right: 0;
	text-align: center;
	letter-spacing: 5px;
	background-color: #6000ff;
	border: solid 1px #6000ff;
	border-radius: 42px;
	opacity: 0.8;
	font-family:'hanyi75';
}
.shop2_search{
	/* width: 300px; */
	z-index: 99999;
	height: 40px;
	position: absolute;
	background-color: #000000;
	border: solid 1px #282839;
	border-radius: 40px;
	top: 0.7%;
	max-width: 500px;
	min-width: 200px;
	background-image: url("../../assets/image/search.png");
	background-repeat: no-repeat;
	background-position: 10px center; /* 图标位置 */
	background-size: 20px 20px;
	padding-left: 40px;
	opacity: 0.7;
	padding-right: 20px;

}
.shop2_searchi{
	z-index: 99999;
	background-color: #000000;
	border: none;
	outline: none;
	color: #04ddc0;
	line-height: 40px;
	font-size: 14px;
}






ul li{
  font-family: 'hanyi75',sans-serif;
  font-weight: 400;
}
@keyframes float {
  0% { transform: translate(20px, 20px); }
  20% { transform: translate(900px, 80px); }
  40% { transform: translate(750px, 500px); }
  60% { transform: translate(900px, 900px); }
  80% { transform: translate(50px, 950px); }
  100% { transform: translate(20px, 20px); }
}

.float-animation {
  /* display: inline-block; */
  animation: float 30s infinite;
}
@keyframes float1 {
  0% { transform: translate(950px, 900px); }
  20% { transform: translate(20px, 850px); }
  40% { transform: translate(300px, 500px); }
  60% { transform: translate(20px, 20px); }
  80% { transform: translate(950px, 50px); }
  100% { transform: translate(950px, 900px); }
}

.float-animation1 {
  /* display: inline-block; */
  animation: float1 30s infinite;
}
.donghuap{
  display: flex;
  justify-content: center;
  /* flex-direction: column; */
  overflow-x: hidden;
  position: relative;
  text-align: center;
  border: 1px solid #BBBBBB;
  flex-grow: 0;
}
.donghuai{
  display: flex;
  transform: translateX(200%);
  transition: transform 0.4s ease;
  justify-content: center;
  flex-grow: 0;
}
.adonghua{
  visibility: hidden;
}
.ddonghua{
  transform: translateX(0);
}
.edonghua{
  display: flex;
  transform: translateX(-200%);
  transition: transform 0.6s ease;
  justify-content: center;
}
.el-dropdown-menu__item{
  color: #ffffff;
  font-weight: bold;
  font-family: guanwangdaohang;
}
.popper__arrow{
  display: none;
}

  .content{
  	background: #939AA0;
  	width: 100%;
  	height: 100%;
  }
  body {
  overflow-x:hidden;
  overflow-y:hidden;
  }
  .el-scrollbar__wrap{
    background-color: black;
  }
  .bordered-box{
     overflow-wrap: break-word;
     /* margin-left: 20px; */
  }

 .beian1 {
    position: fixed; /* 定位为固定位置，覆盖整个视窗 */
    color: #616161;
    /* top: 0; */
    left: 42%;
    /* right: 0; */
    bottom: 0;

    z-index: 1000; /* 确保蒙层在其他内容之上 */
  }




</style>



// WEBPACK FOOTER //
// src/components/main/shop2.vue